import { useMemo } from 'react';
import { DESKTOP_VERSION_WIDTH_THRESHOLD } from '~/_shared/utils/deviceDetect/deviceDetect.helpers';
import { useDeviceInfoScreenWidthSelector } from '~/store/frontendState/deviceInfo/deviceInfo.selector';
import { useIsMapPresentationalSelector } from '~/store/selectors/useMapInfoSelectors';
import { useIsPdfExportEnabledSelector } from '~/store/userData/userData.selectors';

export const useIsExportReportAvailable = () => {
  const isMapPresentational = useIsMapPresentationalSelector();
  const screenWidth = useDeviceInfoScreenWidthSelector();
  const isPdfExportEnabled = useIsPdfExportEnabledSelector();

  const isExportReportAvailable = useMemo(() => {
    return isPdfExportEnabled && !isMapPresentational && screenWidth >= DESKTOP_VERSION_WIDTH_THRESHOLD;
  }, [isPdfExportEnabled, isMapPresentational, screenWidth]);

  return {
    isExportReportAvailable,
  };
};
